/**
 * Similar to 'openIFrameDialog' but in place of 'callback' return a promise that will be resolved when the dialog is closed.
 * If the callback is invoked by 'CRUD' environment, then it will be called with an argument (the ID of the selected document), otherwise without arguments
 */
hrd.dashboard.showIFrameDialog = function(url, param, options){
	var deferred = $.Deferred();
	hrd.dashboard.openIFrameDialog(url, param, options, deferred.resolve);
	return deferred.promise();
}

/**
 * Utility method used to open a dialog with an iframe with external info
 * 	- useful for CRUD visibility
 * 	- useful for PDF rendering
 * @param url
 * @param param
 * @param options
 * @param callBack
 */
hrd.dashboard.openIFrameDialog = function(url, param, options, callBack) {
	var defaults = {
		customId: undefined,
		dialogClass: undefined,
		title: 'IFrame',
		width: 1256,
		height: 800,
		hGap: 100,
		vGap: 60,
		modal: true,
		keepPrevOptions: false,
		actionURI : true,
		remoteCallbackInvocation: true,
		isPrintWizard: false,
		customDimensions: false,
		position: 'center',
		resizable: true,
		draggable: true,
		closable: true,
		maximizable: true,
		minimizable: true,
		minimizeLocation: 'right',
		resizeOnDlbclick: true,
		closeOnOverlay: false,
		hideHeader: false,
		autoOpen: false,
		onOpen: undefined,
		showCloseButton: false,
		buttons: []
	};
	options = $.extend({}, defaults, options);
	
	const dialogId = (options.customId != undefined) ? `${options.customId}-dialog` : 'dashboard-iframe-dialog';
	const dialogIdSelector = `#${dialogId}`;

	const dialogFrameId = (options.customId != undefined) ? options.customId : 'dashboard-iframe';
	const dialogFrameIdSelector = `#${dialogFrameId}`;
	
	var $dialog = $(dialogIdSelector);

	var viewport = {w: $(window).width() - options.hGap, h: $(window).height() - options.vGap};

	// adding support for layout-size
	options.width = dashboardInstance.adaptSize(options.width);
	options.height = dashboardInstance.adaptSize(options.height);
	
//	console.log(options.customDimensions, 'w', options.width, viewport.w)
//	console.log(options.customDimensions, 'h', options.height, viewport.h)

	/* forcing width/height to be as greater as possible but in the viewport */
	options.width = options.customDimensions ? Math.min(options.width, viewport.w) : viewport.w;
	options.height = options.customDimensions ? Math.min(options.height, viewport.h) : viewport.h;

	if(!$dialog.exists()){
		var tmpl =  `
			<div id="${dialogId}" title="" class="iframe-dialog ui-helper-hidden" style="display:none;">
				<iframe id="${dialogFrameId}" style="width:100%;height:100%;" src=""></iframe>
			</div>
		`;
		$('body').append(tmpl);
		$dialog = $(dialogIdSelector); // reassign for safe
	}

	/** buttons rework **/
	if(options.buttons.length > 0 || options.showCloseButton){
		// wrap each button function in order to close the dialog once completed (via promise)
		options.buttons.forEach(b => {
			if(typeof b.click === 'function'){
				let origClick = b.click;
				b.click = () => $.when(origClick.call($dialog)).then(() => $dialog.dialog('close'));
			}
		});
		// finally append always the close button
		let closeBtn = {'text': xlate('common.dialog.close.btn'), 'class': 'close-button', 'click': function(){$(this).dialog('close');}};
		options.buttons.push(closeBtn);
	}
	/********************/

	let dialogClasses = ['ui-iframe-dialog'];
	if(options.dialogClass != undefined) {
		dialogClasses.push(options.dialogClass);
	}
	
	var uri = options.actionURI ? hrd.fn.actionURI(url) : url;
	callBack = callBack ? callBack.bind(this) : $.noop;
	var args = options.actionURI ? $.extend({}, param , {navMode : 'externalPopup'}) : $.extend({}, param);
	var qs = $.param(args, true);
	let $iframeDialog = this.retrieveIframeDialogInstance(dialogId);
	
	if($iframeDialog == null || !options.customId) {
		$(dialogFrameIdSelector).attr('src', uri + (qs ? '?' + qs : ''));
	}

	if($iframeDialog == null) {
		$iframeDialog = $dialog.dialog({
			dialogClass: dialogClasses.join(' '),
			autoOpen: options.autoOpen,
			position: options.position,
			resizable: options.resizable,
			draggable: options.draggable,
			buttons: options.buttons,
			closable: options.closable,
			maximizable: options.maximizable,
			maximizeIcon: 'f-icon far fa-window-maximize',
			minimizable: options.minimizable,
			minimizeIcon: 'f-icon far fa-window-minimize',
			minimizeLocation: 'right',
			resizeOnDlbclick: options.resizeOnDlbclick,
			restoreIcon: 'f-icon far fa-window-restore',
			create: (event, ui) => {
				if(options.hideHeader){
					$dialog.parent().find('.ui-dialog-titlebar').hide();
				}
			},
			open: (event, ui) => {
				if(typeof options.onOpen === 'function'){
					options.onOpen.call($iframeDialog, event, ui);
				}
				if(options.closeOnOverlay){
					$('.ui-widget-overlay').on('click', () => {
						$dialog.dialog('close');
					});
				}
			}
		});
		this.storeIframeDialogInstance(dialogId, $iframeDialog);
	}
	// rimuovo precedenti valori della 'callback-called'
	$iframeDialog.removeData('callback-called', true);

	if(options.remoteCallbackInvocation){
		// needed for CRUD in navManager.closejq only of remoteCallbackInvocation is true
		$iframeDialog.data('callback', callBack);
	}
	$iframeDialog.off('dialogclose');
	$iframeDialog.on('dialogclose', (event, ui) => {
		if(options.customId == undefined) {
			// reset uri
			$(dialogFrameIdSelector).attr('src', '');
		}
		if(callBack){
			if(!options.remoteCallbackInvocation){
				callBack();
			} else {
				let callbackCalled = $iframeDialog.data('callback-called');
				if(!callbackCalled) {
					callBack();
				}
			}
		}

	});
	if(!options.keepPrevOptions){
		$iframeDialog.dialog('option', 'title', options.title);
		$iframeDialog.dialog('option', 'modal', options.modal);
		$iframeDialog.dialog('option', 'width', options.width);
		$iframeDialog.dialog('option', 'height', options.height);
		$iframeDialog.dialog('option', 'buttons', options.buttons);
		$iframeDialog.dialog('open');
	}
}

hrd.dashboard.reuseIFrameDialog = function(url, param, callBack){
	this.openIFrameDialog(url, param, {keepPrevOptions:true}, callBack);
}

hrd.dashboard.closeCurrentIFrameDialog = function(customId){
	const dialogId = (customId != undefined) ? `#${customId}-dialog` : '#dashboard-iframe-dialog';
	$(dialogId).dialog('close');
}

hrd.dashboard.setIFrameDialogTitle = function(title, customId){
	const dialogId = (customId != undefined) ? `#${customId}-dialog` : '#dashboard-iframe-dialog';
	let $dialog = $(dialogId);
	if($dialog){
		$dialog.dialog('option', 'title', title);
	}
}

hrd.dashboard.appendIFrameDialogTitle = function(suffix, customId){
	const dialogId = (customId != undefined) ? `#${customId}-dialog` : '#dashboard-iframe-dialog';
	let $dialog = $(dialogId);
	if($dialog){
		let originalTitle = $dialog.data('originalTitle');
		if(originalTitle == undefined) {
			originalTitle = $dialog.dialog('option', 'title');
			$dialog.data('originalTitle', originalTitle);
		}
		let title = (suffix == undefined) ? originalTitle : `${originalTitle} ${suffix}`;
		$dialog.dialog('option', 'title', title);
	}
}

hrd.dashboard.retrieveIframeDialogInstance = function(dialogId) {
	let repository = this.getDialogRepository();
	return repository[dialogId];
}

hrd.dashboard.storeIframeDialogInstance = function(dialogId, dialogInstance) {
	let repository = this.getDialogRepository();
	repository[dialogId] = dialogInstance;
}

hrd.dashboard.getDialogRepository = function() {
	if(this.dialogInstanceRepository == undefined) {
		this.dialogInstanceRepository = {};
	}
	return this.dialogInstanceRepository;
}